import React from 'react';
import Input from 'es6/components/registration/inputs/input';

function ForceCountryInput(props) {
  return (<Input type="hidden" name="force_country" {...props} />);
}

export default ForceCountryInput;
